export default "/images/vendor/flag-icon-css/flags/4x3/bo.svg?88ba0b0a7e48ec71eca867a6a125b743";